import React from "react";
import EN from "../../locales/en";
import { substituteLinksInText } from "../../utils/switching";

const YourAgreement = ({ config }) => {
  return (
    !!config && (
      <div className="mt-8 border-t border-[#afb6b9]">
        <div>
          <h2 className="text-[30px] font-bold text-primary mt-6">
            {EN.switch.your_agreement.title}
          </h2>
          {Object.keys(config.data).map((key) => {
            const section = config.data[key];

            if (!section.isVisible) {
              return null;
            }

            const { displayText, link } = section;

            let links = [];

            if (Array.isArray(link)) {
              links = link;
            } else if (link) {
              links = [link];
            }

            return (
              <div key={key}>
                <p className="mt-4 text-md leading-[1.5]">
                  {substituteLinksInText(displayText, links)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

export default YourAgreement;
